import { useBeforeLeave } from '@solidjs/router'
import { Modal } from 'solid-bootstrap'
import { FaSolidX } from 'solid-icons/fa'
import { Component } from 'solid-js'
import { Dynamic } from 'solid-js/web'
import { getModalMenu, setModalMenu } from '../../rx/shared/ModalMenu/ModalMenuSignal'

const MainMenuModal: Component = () => {
  const closeMenu = () => setModalMenu()

  // if the user navigates away from the page, close the menu
  useBeforeLeave(closeMenu)

  // createEffect(() => {
  //   console.log('getSelectedMenu', getSelectedMenu())
  // })

  // if (DEV) {
  //   onMount(() => {
  //     setModalMenu(ModalMenuMain)
  //     setModalMenu(ModalMenuDeviceSettings)
  //     setModalMenu(InputProfileListPage)
  //   })
  // }

  return (
    <Modal show={getModalMenu()} onHide={closeMenu} centered
      fullscreen={getModalMenu()?.fullscreen}
      size={getModalMenu()?.size}
    >
      <Modal.Body>
        <div class="float-end text-muted" onClick={closeMenu}><FaSolidX /></div>
        <h2 class="text-center w-100">{getModalMenu()?.dname}</h2>
        <Dynamic component={getModalMenu()?.fn} />
      </Modal.Body>
    </Modal>
  )
}

export default MainMenuModal
